import { createPlatformClient as platformClientCreator } from '@msgn/fl-module/fl-platform-authorizer';
import { PlatformClient } from './playerApi.types';

export const createPlatformClient = (clientId?: string, clientName?: string): PlatformClient => {
  return platformClientCreator(clientId, clientName);
};
